'use client';

import { Button } from '@app/app/_components/Button/Button';
import { Input } from '@app/app/_components/Input/Input';
import { DiscountCodeData } from '@app/domain/model/eshop/transport/DiscountCodeData';
import { useTranslations } from 'next-intl';

interface Props {
    handleDiscountCode: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleApplyDiscountClick: () => void;
    discountCodeData: DiscountCodeData;
}

export function DiscountCode({ handleDiscountCode, handleApplyDiscountClick, discountCodeData }: Props) {
    const t = useTranslations();

    return (
        <div className="md:self-start">
            <Input
                label={t('eshop.general.discountCodeLabel')}
                placeholder={t('eshop.general.discountCodePlaceholder')}
                onChange={handleDiscountCode}
                successMessage={discountCodeData.isSuccess ? t('eshop.general.discountCodeSuccess') : ''}
                error={discountCodeData.isInvalid ? { message: 'eshop.general.discountCodeInvalid' } : undefined}
                defaultValue={discountCodeData.discountCode}
                size={20}
                rightAddon={
                    <Button
                        ignoreFormStatus
                        variant="outlined"
                        preventDefault
                        className="rounded-l-none rounded-r-md"
                        size="small"
                        onClick={handleApplyDiscountClick}>
                        {t('eshop.general.applyDiscount')}
                    </Button>
                }
            />
        </div>
    );
}
